<mat-radio-group *ngIf="!environment.production" class="flex flex-row lg:justify-end justify-between w-full"
(ngModelChange)="onChange($event)"
  [(ngModel)]="keySelected">
  <mat-radio-button class="px-2" *ngFor="let key of filters" [value]="key">
    {{this.utils.traslatei18n(key)}}
  </mat-radio-button>
</mat-radio-group>

